// removed by extract-text-webpack-plugin
module.exports = {"carousel":"_2_fN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/JobDescription/Team/Carousel/styles.scss
// module id = 469
// module chunks = 0